export default function formatAddress(address) {
  try {
    const parsedAddress = address.split(",");
    let returnedAddress = address;

    if (parsedAddress.length >= 1) {
      returnedAddress = parsedAddress[0] + "," + parsedAddress[1];
    }

    return returnedAddress;
  } catch (e) {
    return address;
  }
}
